var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59613 2.36994C2.53635 0.720767 6.45989 0.374143 8.08292 2.36994C9.70596 4.36573 12.4291 24.4508 12.4291 24.4508C12.5774 25.2101 12.9835 25.892 13.5765 26.3774C14.1695 26.8628 14.9114 27.1207 15.6725 27.1058H31.4354C32.1964 27.1207 32.9384 26.8628 33.5313 26.3774C34.1243 25.892 34.5305 25.2101 34.6788 24.4508C34.6788 24.4508 39.8682 14.7813 37.2735 10.6152C34.6788 6.44917 10.8732 10.6152 10.8732 10.6152M16.1941 35.3509C16.1941 36.2617 15.468 37 14.5724 37C13.6767 37 12.9507 36.2617 12.9507 35.3509C12.9507 34.4402 13.6767 33.7019 14.5724 33.7019C15.468 33.7019 16.1941 34.4402 16.1941 35.3509ZM3.04846 2.8034C3.04846 3.37861 2.5899 3.84491 2.02423 3.84491C1.45856 3.84491 1 3.37861 1 2.8034C1 2.22819 1.45856 1.76189 2.02423 1.76189C2.5899 1.76189 3.04846 2.22819 3.04846 2.8034ZM34.0301 35.3509C34.0301 36.2617 33.304 37 32.4084 37C31.5128 37 30.7867 36.2617 30.7867 35.3509C30.7867 34.4402 31.5128 33.7019 32.4084 33.7019C33.304 33.7019 34.0301 34.4402 34.0301 35.3509Z",
    stroke: "#11141D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.59951a77881c4f939497338b394721fd.svg";
export { ForwardRef as ReactComponent };